'use client';
import dynamic from 'next/dynamic';

import { Modal } from '~components/Modals/Base';
import type { TModalProps } from '~components/Modals/types';

import type { NeuronsModalProps } from '../../model/types';

const Content = dynamic(() => import('./Content').then((mod) => mod.Content), {
	ssr: false,
});

export const NeuronsModal = ({
	open,
	locked,
	onClose,
	...props
}: NeuronsModalProps & TModalProps) => {
	return (
		<Modal open={open} locked={locked} onClose={onClose}>
			<Content open={open} locked={locked} onClose={onClose} {...props} />
		</Modal>
	);
};
